import { skillListConstant } from 'src/redux/actions/constant';

const { GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE, GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS } =
  skillListConstant;

const intialState: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getSkillsListReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload,
      };
    }
    case GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE: {
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };
    }

    default:
      return state;
  }
};
